import { View, Text, Modal, Platform } from "react-native";
import React from "react";
import { WebView } from "react-native-webview";
import { useDeviceSize, CreateResponsiveStyle } from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";
import { TouchableOpacity } from "react-native-gesture-handler";

export default function PaymentScreen(props) {
  const {
    showModal = false,
    setShowModal,
    paymentCreateSessionData,
    confirmSuccess = () => {},
  } = props;

  const onCloseClick = () => {
    setShowModal(false);
  };

  const styles = useStyles();
  const deviceSize = useDeviceSize();

  return (
    <>
      <Modal
        animationType="fade"
        transparent={true}
        visible={showModal}
        onRequestClose={onCloseClick}
      >
        <View style={styles.container}>
          <TouchableOpacity
            style={{ height: 50, width: 100, backgroundColor: "red" }}
            onPress={onCloseClick}
          />
          {Platform.OS === "web" ? (
            <iframe
              src={paymentCreateSessionData.url}
              width={"80%"}
              height={"80%"}
            />
          ) : (
            // <WebView
            //     source={{ uri: paymentCreateSessionData.url }}
            //     style={{ marginTop: 22, flex: 1 }}
            // />

            // Linking.openURL("https://checkout.stripe.com/c/pay/cs_test_a13K0DiT677vPgD3DLFj1U4KF6srT1pK48PrELjyCkKwfST1dkRsKNeWJd#fid1d2BpamRhQ2prcSc%2FJ1dqZ2pxaicpJ2R1bE5gfCc%2FJ3VuWnFgdnFaMDRKYmlfQEBrR2hzbnNfPUhdPGRwM0lfdlJ0U2hxSTFXVGxBMWNVcjVCV108TWtoYn9mYndmPXBBN3dERFN0SDNjRnFsVX9obDJdMktudlFuYEpVSjNJamE1NUNuVTV3TGJgJyknY3dqaFZgd3Ngdyc%2FcXdwYCknaWR8anBxUXx1YCc%2FJ3Zsa2JpYFpscWBoJyknYGtkZ2lgVWlkZmBtamlhYHd2Jz9xd3BgeCUl");

            <View style={{ flex: 1 }}>
              <WebView
                source={{ uri: "https://www.google.com/" }}
                style={{ marginTop: 22, flex: 1 }}
                onNavigationStateChange={(navState) => {
                  console.log("navState::: - ", navState);
                }}
              />
            </View>
          )}
          {/* <WebView
                    source={{ uri: "https://www.google.com/" }}
                    style={{ flex: 1, }}
                /> */}
          {/* <WebView
                    source={{ uri: 'https://www.youtube.com/embed/MhkGQAoc7bc' }}
                    style={{ flex: 1 }}
                    javaScriptEnabled={true}
                    domStorageEnabled={true}
                    startInLoadingState={false}
                    scalesPageToFit={true}
                /> */}
        </View>
      </Modal>
    </>
  );
}

const useStyles = CreateResponsiveStyle({
  container: {
    flex: 1,
    backgroundColor: AppColors.blackTrans_000000a8,
    justifyContent: "center",
    alignItems: "center",
  },
  mainView: {
    width: "35%",
    backgroundColor: AppColors.black_121212,
    paddingHorizontal: 30,
    marginHorizontal: 40,
    marginVertical: 50,
    alignSelf: "center",
    borderRadius: 12,
  },
});
